import { axiosConToken } from "../helpers/axios";
import { types } from "../types/typesProgramacion";
import {
  messageLoading,
  messageSuccessLoading,
  validaMessagesErrors,
} from "../helpers/messageConfig";
import { open_file } from "../helpers/utils";
import { PATH_PRODUCCION } from "../constants/routes";

const key = "msgproduccion";
//TODO: MAQUINAS
export const maquinaStartLoad = () => {
  return async (dispatch) => {
    try {
      const resp = await axiosConToken.get(PATH_PRODUCCION.maquina);
      const body = resp.data;
      dispatch(maquinaLoaded(body));
    } catch (error) {
      validaMessagesErrors(error, key);
    }
  };
};
export const maquinaStartAdd = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.post(PATH_PRODUCCION.maquina, data);
      const body = resp.data;
      const { msg, maquina } = body;
      dispatch(maquinaInserted(maquina));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
export const maquinaStartUpdate = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.put(
        `${PATH_PRODUCCION.maquina}${data.id}/`,
        data,
      );
      const body = resp.data;
      const { msg, maquina } = body;
      dispatch(maquinaUpdated(maquina));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
export const maquinaStartDelete = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.delete(
        `${PATH_PRODUCCION.maquina}${data.id}/`,
      );
      const { msg } = resp.data;
      dispatch(maquinaDeleted(data));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, key);
    }
  };
};
const maquinaLoaded = (data) => ({
  type: types.maquinasLoaded,
  payload: data,
});
const maquinaInserted = (maquina) => ({
  type: types.maquinasInserted,
  payload: maquina,
});
const maquinaUpdated = (maquina) => ({
  type: types.maquinasUpdated,
  payload: maquina,
});
const maquinaDeleted = (maquina) => ({
  type: types.maquinasDeleted,
  payload: maquina,
});
export const maquinaSetActive = (maquina) => ({
  type: types.maquinasSetActive,
  payload: maquina,
});
export const maquinaClearActive = () => ({
  type: types.maquinasClearActive,
});
//TODO: TAREAS DE PRODUCCION
export const tareaProduccionStartLoad = () => {
  return async (dispatch) => {
    try {
      const resp = await axiosConToken.get(PATH_PRODUCCION.tareaproduccion);
      const body = resp.data;
      dispatch(tareaProduccionLoaded(body));
    } catch (error) {
      validaMessagesErrors(error, key);
    }
  };
};
export const tareaProduccionStartAdd = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.post(
        PATH_PRODUCCION.tareaproduccion,
        data,
      );
      const body = resp.data;
      const { msg, tareaproduccion } = body;
      dispatch(tareaProduccionInserted(tareaproduccion));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
export const tareaProduccionStartUpdate = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.put(
        `${PATH_PRODUCCION.tareaproduccion}${data.id}/`,
        data,
      );
      const body = resp.data;
      const { msg, tareaproduccion } = body;
      dispatch(tareaProduccionUpdated(tareaproduccion));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
export const tareaProduccionStartDelete = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.delete(
        `${PATH_PRODUCCION.tareaproduccion}${data.id}/`,
      );
      const { msg } = resp.data;
      dispatch(tareaProduccionDeleted(data));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, key);
    }
  };
};
const tareaProduccionLoaded = (data) => ({
  type: types.tareasProduccionLoaded,
  payload: data,
});
const tareaProduccionInserted = (tareaproduccion) => ({
  type: types.tareasProduccionInserted,
  payload: tareaproduccion,
});
const tareaProduccionUpdated = (tareaproduccion) => ({
  type: types.tareasProduccionUpdated,
  payload: tareaproduccion,
});
const tareaProduccionDeleted = (tareaproduccion) => ({
  type: types.tareasProduccionDeleted,
  payload: tareaproduccion,
});
export const tareaProduccionSetActive = (tareaproduccion) => ({
  type: types.tareasProduccionSetActive,
  payload: tareaproduccion,
});
export const tareaProduccionClearActive = () => ({
  type: types.tareasProduccionClearActive,
});

//TODO: RUTAS DE PRODUCCION
export const rutaProduccionStartLoad = () => {
  return async (dispatch) => {
    try {
      const resp = await axiosConToken.get(PATH_PRODUCCION.rutaproduccion);
      const body = resp.data;
      dispatch(rutaProduccionLoaded(body));
    } catch (error) {
      validaMessagesErrors(error, key);
    }
  };
};
export const rutaProduccionStartAdd = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.post(
        PATH_PRODUCCION.rutaproduccion,
        data,
      );
      const body = resp.data;
      const { msg, rutaproduccion } = body;
      dispatch(rutaProduccionInserted(rutaproduccion));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
export const rutaProduccionStartUpdate = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.put(
        `${PATH_PRODUCCION.rutaproduccion}${data.id}/`,
        data,
      );
      const body = resp.data;
      const { msg, rutaproduccion } = body;
      dispatch(rutaProduccionUpdated(rutaproduccion));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
export const rutaProduccionStartDelete = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.delete(
        `${PATH_PRODUCCION.rutaproduccion}${data.id}/`,
      );
      const { msg } = resp.data;
      dispatch(rutaProduccionDeleted(data));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, key);
    }
  };
};
const rutaProduccionLoaded = (data) => ({
  type: types.rutasProduccionLoaded,
  payload: data,
});
const rutaProduccionInserted = (rutaproduccion) => ({
  type: types.rutasProduccionInserted,
  payload: rutaproduccion,
});
const rutaProduccionUpdated = (rutaproduccion) => ({
  type: types.rutasProduccionUpdated,
  payload: rutaproduccion,
});
const rutaProduccionDeleted = (rutaproduccion) => ({
  type: types.rutasProduccionDeleted,
  payload: rutaproduccion,
});
export const rutaProduccionSetActive = (rutaproduccion) => ({
  type: types.rutasProduccionSetActive,
  payload: rutaproduccion,
});
export const rutaProduccionClearActive = () => ({
  type: types.rutasProduccionClearActive,
});
export const showFormRutaProduccion = (visible = true) => ({
  type: types.rutasProduccionShowForm,
  payload: visible,
});

//TODO: ORDENES DE PRODUCCION
export const ordenProduccionStartLoad = () => {
  return async (dispatch) => {
    try {
      const resp = await axiosConToken.get(PATH_PRODUCCION.ordenproduccion);
      const body = resp.data;
      dispatch(ordenProduccionLoaded(body));
    } catch (error) {
      validaMessagesErrors(error, key);
    }
  };
};
export const ordenProduccionStartAdd = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.post(
        PATH_PRODUCCION.ordenproduccion,
        data,
      );
      const body = resp.data;
      const { msg, ordenproduccion } = body;
      dispatch(ordenProduccionInserted(ordenproduccion));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
export const ordenProduccionStartUpdate = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.put(
        `${PATH_PRODUCCION.ordenproduccion}${data.id}/`,
        data,
      );
      const body = resp.data;
      const { msg, ordenproduccion } = body;
      dispatch(ordenProduccionUpdated(ordenproduccion));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
export const ordenProduccionStartDelete = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.delete(
        `${PATH_PRODUCCION.ordenproduccion}${data.id}/`,
      );
      const { msg } = resp.data;
      dispatch(ordenProduccionDeleted(data));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, key);
    }
  };
};
const ordenProduccionLoaded = (data) => ({
  type: types.ordenesProduccionLoaded,
  payload: data,
});
const ordenProduccionInserted = (ordenproduccion) => ({
  type: types.ordenesProduccionInserted,
  payload: ordenproduccion,
});
const ordenProduccionUpdated = (ordenproduccion) => ({
  type: types.ordenesProduccionUpdated,
  payload: ordenproduccion,
});
const ordenProduccionDeleted = (ordenproduccion) => ({
  type: types.ordenesProduccionDeleted,
  payload: ordenproduccion,
});
export const ordenProduccionSetActive = (ordenproduccion) => ({
  type: types.ordenesProduccionSetActive,
  payload: ordenproduccion,
});
export const ordenProduccionClearActive = () => ({
  type: types.ordenesProduccionClearActive,
});
export const showFormOrdenProduccion = (visible = true) => ({
  type: types.ordenesProduccionShowForm,
  payload: visible,
});

//TODO: PROCESOS PRODUCCION

export const procesoProduccionStartLoad = () => {
  return async (dispatch) => {
    try {
      const resp = await axiosConToken.get(PATH_PRODUCCION.procesoproduccion);
      const body = resp.data;
      dispatch(procesoProduccionLoaded(body));
    } catch (error) {
      validaMessagesErrors(error, key);
    }
  };
};
export const procesoProduccionStartAdd = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.post(
        PATH_PRODUCCION.procesoproduccion,
        data,
      );
      const body = resp.data;
      const { msg, procesoproduccion } = body;
      dispatch(procesoProduccionInserted(procesoproduccion));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
export const procesoProduccionStartUpdate = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.put(
        `${PATH_PRODUCCION.procesoproduccion}${data.id}/`,
        data,
      );
      const body = resp.data;
      const { msg, procesoproduccion } = body;
      dispatch(procesoProduccionUpdated(procesoproduccion));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
export const procesoProduccionStartDelete = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.delete(
        `${PATH_PRODUCCION.procesoproduccion}${data.id}/`,
      );
      const { msg } = resp.data;
      dispatch(procesoProduccionDeleted(data));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, key);
    }
  };
};
const procesoProduccionLoaded = (data) => ({
  type: types.procesosProduccionLoaded,
  payload: data,
});
const procesoProduccionInserted = (procesoproduccion) => ({
  type: types.procesosProduccionInserted,
  payload: procesoproduccion,
});
const procesoProduccionUpdated = (procesoproduccion) => ({
  type: types.procesosProduccionUpdated,
  payload: procesoproduccion,
});
const procesoProduccionDeleted = (procesoproduccion) => ({
  type: types.procesosProduccionDeleted,
  payload: procesoproduccion,
});
export const procesoProduccionSetActive = (procesoproduccion) => ({
  type: types.procesosProduccionSetActive,
  payload: procesoproduccion,
});
export const procesoProduccionClearActive = () => ({
  type: types.procesosProduccionClearActive,
});
export const showFormProcesoProduccion = (visible = true) => ({
  type: types.procesosProduccionShowForm,
  payload: visible,
});
export const detalleProcesoProduccionSetActive = (detalle) => ({
  type: types.detalleProcesoProduccionSetActive,
  payload: detalle,
});
export const detalleProcesoProduccionClearActive = () => ({
  type: types.detalleProcesoProduccionClearActive,
});
export const programacionStatusLoading = (loading = true) => ({
  type: types.dataLoading,
  payload: loading,
});
export const programacionTejidoStartLoad = ({
  fechainicio_after = null,
  fechainicio_before = null,
  search = null,
  page = 1,
  page_size = 10,
}) => {
  return async (dispatch) => {
    dispatch(programacionStatusLoading());
    try {
      const resp = await axiosConToken.get(PATH_PRODUCCION.programaciontejido, {
        params: {
          fechainicio_after,
          fechainicio_before,
          search,
          page,
          page_size,
        },
      });
      dispatch(programacionTejidoLoaded(resp.data));
      dispatch(
        setFilterSearchProgramacionTejido({
          fechainicio_after,
          fechainicio_before,
          search,
          page,
          page_size,
        }),
      );
    } catch (error) {
      validaMessagesErrors(error, key);
    } finally {
      dispatch(programacionStatusLoading(false));
    }
  };
};
export const programacionTejidoStartAdd = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.post(
        PATH_PRODUCCION.programaciontejido,
        data,
      );
      const body = resp.data;
      const { msg, programaciontejido } = body;
      dispatch(programacionTejidoInserted(programaciontejido));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
export const programacionTejidoStartUpdate = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.put(
        `${PATH_PRODUCCION.programaciontejido}${data.id}/`,
        data,
      );
      const body = resp.data;
      const { msg, programaciontejido } = body;
      dispatch(programacionTejidoUpdated(programaciontejido));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};

export const programacionTejidoStartDelete = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.delete(
        `${PATH_PRODUCCION.programaciontejido}${data.id}/`,
      );
      const { msg } = resp.data;
      dispatch(programacionTejidoDeleted(data));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, key);
    }
  };
};
export const programacionTejidoSaldosStartProcess = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.post(
        `${PATH_PRODUCCION.programaciontejido}procesar_saldosprogramaciontejido_en_inventario/`,
        data,
      );
      const body = resp.data;
      const { msg, programaciontejido } = body;
      dispatch(programacionTejidoUpdated(programaciontejido));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};

export const programacionTintoreriaStartLoad = ({
  fechainicio_after = null,
  fechainicio_before = null,
  search = null,
  page = 1,
  page_size = 10,
}) => {
  return async (dispatch) => {
    dispatch(programacionStatusLoading());
    try {
      const resp = await axiosConToken.get(
        PATH_PRODUCCION.programaciontintoreria,
        {
          params: {
            fechainicio_after,
            fechainicio_before,
            search,
            page,
            page_size,
          },
        },
      );
      dispatch(programacionTintoreriaLoaded(resp.data));
    } catch (error) {
      validaMessagesErrors(error, key);
    } finally {
      dispatch(programacionStatusLoading(false));
    }
  };
};
export const programacionTintoreriaStartAdd = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.post(
        PATH_PRODUCCION.programaciontintoreria,
        data,
      );
      const body = resp.data;
      const { msg, programaciontintoreria } = body;
      dispatch(programacionTintoreriaInserted(programaciontintoreria));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
export const programacionTintoreriaStartUpdate = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.put(
        `${PATH_PRODUCCION.programaciontintoreria}${data.id}/`,
        data,
      );
      const body = resp.data;
      const { msg, programaciontintoreria } = body;
      dispatch(programacionTintoreriaUpdated(programaciontintoreria));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
export const programacionTintoreriaStartDelete = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.delete(
        `${PATH_PRODUCCION.programaciontintoreria}${data.id}/`,
      );
      const { msg } = resp.data;
      dispatch(programacionTintoreriaDeleted(data));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, key);
    }
  };
};

const programacionTejidoLoaded = (programaciones) => ({
  type: types.programacionTejidoLoaded,
  payload: programaciones,
});
const programacionTejidoInserted = (programaciontejido) => ({
  type: types.programacionTejidoInserted,
  payload: programaciontejido,
});
const programacionTejidoUpdated = (programaciontejido) => ({
  type: types.programacionTejidoUpdated,
  payload: programaciontejido,
});
const programacionTejidoDeleted = (programaciontejido) => ({
  type: types.programacionTejidoDeleted,
  payload: programaciontejido,
});
export const detalleProgramacionTejidoSetActive = (detalle) => ({
  type: types.detalleProgramacionTejidoSetActive,
  payload: detalle,
});
export const detalleProgramacionTejidoClearActive = () => ({
  type: types.detalleProgramacionTejidoClearActive,
});
export const saldoProgramacionTejidoSetActive = (itemsaldo) => ({
  type: types.saldoProgramacionTejidoSetActive,
  payload: itemsaldo,
});
export const saldoProgramacionTejidoClearActive = () => ({
  type: types.saldoProgramacionTejidoClearActive,
});
export const programacionTejidoSetActive = (programaciontejido) => ({
  type: types.programacionTejidoSetActive,
  payload: programaciontejido,
});
export const programacionTejidoClearActive = () => ({
  type: types.programacionTejidoClearActive,
});

export const setFilterSearchProgramacionTejido = (filters) => ({
  type: types.programacionTejidoSetFilterSearch,
  payload: filters,
});
const programacionTintoreriaLoaded = (programaciones) => ({
  type: types.programacionTintoreriaLoaded,
  payload: programaciones,
});
const programacionTintoreriaInserted = (programacion) => ({
  type: types.programacionTintoreriaInserted,
  payload: programacion,
});
const programacionTintoreriaUpdated = (programacion) => ({
  type: types.programacionTintoreriaUpdated,
  payload: programacion,
});
const programacionTintoreriaDeleted = (programacion) => ({
  type: types.programacionTintoreriaDeleted,
  payload: programacion,
});
export const programacionTintoreriaSetActive = (programacion) => ({
  type: types.programacionTintoreriaSetActive,
  payload: programacion,
});
export const programacionTintoreriaClearActive = () => ({
  type: types.programacionTintoreriaClearActive,
});
export const detalleProgramacionTintoreriaSetActive = (detalle) => ({
  type: types.detalleProgramacionTintoreriaSetActive,
  payload: detalle,
});
export const detalleProgramacionTintoreriaClearActive = () => ({
  type: types.detalleProgramacionTintoreriaClearActive,
});
export const showFormProgramacionTintoreria = (visible = true) => ({
  type: types.produccionShowFormProgramacionTintoreria,
  payload: visible,
});
export const consolidadoTelaStartAdd = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.post(
        PATH_PRODUCCION.consolidadotela,
        data,
      );
      const body = resp.data;
      const { msg, programaciontintoreria } = body;
      // dispatch(consolidadoTelaInserted(consolidadotela));
      dispatch(programacionTintoreriaUpdated(programaciontintoreria));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
export const consolidadoTelaStartUpdate = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.put(
        `${PATH_PRODUCCION.consolidadotela}${data.id}/`,
        data,
      );
      const body = resp.data;
      const { msg, programaciontintoreria } = body;
      // dispatch(consolidadoTelaUpdated(consolidadotela));
      dispatch(programacionTintoreriaUpdated(programaciontintoreria));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
export const consolidadoTelaSetActive = (consolidado) => ({
  type: types.consolidadoTelaSetActive,
  payload: consolidado,
});
export const consolidadoTelaClearActive = () => ({
  type: types.consolidadoTelaClearActive,
});
export const showFormConsolidadoTela = (visible = true) => ({
  type: types.produccionShowFormConsolidadoTela,
  payload: visible,
});

//TODO: Resumen producción
const resumenProduccionLoaded = (data) => ({
  type: types.resumenProduccionLoaded,
  payload: data,
});
const resumenProducccionInserted = (data) => ({
  type: types.resumenProduccionInserted,
  payload: data,
});
const resumenProducccionUpdated = (data) => ({
  type: types.resumenProduccionUpdated,
  payload: data,
});
const resumenProducccionDeleted = (data) => ({
  type: types.resumenProduccionDeleted,
  payload: data,
});
export const resumenProduccionSetActive = (data) => ({
  type: types.resumenProduccionSetActive,
  payload: data,
});
export const resumenProduccionClearActive = () => ({
  type: types.resumenProduccionClearActive,
});
export const resumenProduccionStartLoading = () => {
  return async (dispatch) => {
    dispatch(programacionStatusLoading());
    try {
      const resp = await axiosConToken.get(PATH_PRODUCCION.resumenproduccion);
      const body = resp.data;
      dispatch(resumenProduccionLoaded(body));
    } catch (error) {
      validaMessagesErrors(error, key);
    } finally {
      dispatch(programacionStatusLoading(false));
    }
  };
};
export const resumenProduccionStartAdd = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.post(
        PATH_PRODUCCION.resumenproduccion,
        data,
      );
      const { msg, resumenproduccion } = resp.data;
      dispatch(resumenProducccionInserted(resumenproduccion));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
export const resumenProduccionStartUpdate = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.put(
        `${PATH_PRODUCCION.resumenproduccion}${data.id}/`,
        data,
      );
      const { msg, resumenproduccion } = resp.data;
      dispatch(resumenProducccionUpdated(resumenproduccion));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
export const resumenProduccionStartDelete = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.delete(
        `${PATH_PRODUCCION.resumenproduccion}${data.id}/`,
      );
      const { msg } = resp.data;
      dispatch(resumenProducccionDeleted(data));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, key);
    }
  };
};
export const procesarResumenProduccionStartAdd = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.post(
        `${PATH_PRODUCCION.resumenproduccion}save_resumenproduccion_en_inventario/`,
        data,
      );
      const { msg, resumenproduccion } = resp.data;
      dispatch(resumenProducccionUpdated(resumenproduccion));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};

export const detalleResumenProduccionSetActive = (detalleresumen) => ({
  type: types.detalleResumenProduccionSetActive,
  payload: detalleresumen,
});
export const detalleResumenProduccionClearActive = () => ({
  type: types.detalleResumenProduccionClearActive,
});
export const insumoResumenProduccionSetActive = (insumoresumen) => ({
  type: types.insumosResumenProduccionSetActive,
  payload: insumoresumen,
});
export const insumoResumenProduccionClearActive = () => ({
  type: types.insumosResumenProduccionClearActive,
});
//TODO: Implement extra functions - RESUMEN PRODUCCION
//TODO: ASYNC FUNCTIONS
export const get_pdf_resumenproduccion = async (resumenproduccion) => {
  let datos = [];
  try {
    const resp = await axiosConToken.get(
      `${PATH_PRODUCCION.resumenproduccion}get_pdf_resumenproduccion/`,
      {
        responseType: "blob",
        params: { resumenproduccion },
      },
    );
    datos = resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
  return datos;
};

//TODO: Implement extra functions
//TODO: ASYNC FUNCTIONS
export const search_Items_by_param = async (param) => {
  try {
    const resp = await axiosConToken.get(
      `${PATH_PRODUCCION.resumenproduccion}search_items_by_param/`,
      { params: { param } },
    );
    return resp.data;
  } catch (error) {
    validaMessagesErrors(error.response);
  }
};

export const search_comprobantesmovimiento_produccion_by_param = async (
  param,
) => {
  try {
    const resp = await axiosConToken.get(
      `${PATH_PRODUCCION.resumenproduccion}search_comprobantesmovimiento_produccion_by_param/`,
      { params: { param } },
    );
    return resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
};

export const get_estados_programacion_tejido = async () => {
  let datos = [];
  try {
    const resp = await axiosConToken.get(
      `${PATH_PRODUCCION.programaciontejido}get_estados_programaciontejido/`,
    );
    datos = resp.data;
  } catch (error) {
    validaMessagesErrors(error.response);
  }
  return datos;
};
export const get_tipostelas = async () => {
  try {
    const resp = await axiosConToken.get(
      `${PATH_PRODUCCION.programaciontejido}get_tipostelas/`,
    );
    return resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
};
export const get_colores = async () => {
  try {
    const resp = await axiosConToken.get(
      `${PATH_PRODUCCION.programaciontejido}get_colores/`,
    );
    return resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
};
export const get_tipo_tenido_tela = async () => {
  let datos = [];
  try {
    const resp = await axiosConToken.get(
      `${PATH_PRODUCCION.programaciontejido}get_tipotenidotela/`,
    );
    datos = resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
  return datos;
};
export const get_ancho_tela = async () => {
  let datos = [];
  try {
    const resp = await axiosConToken.get(
      `${PATH_PRODUCCION.programaciontejido}get_anchotela/`,
    );
    datos = resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
  return datos;
};
export const get_pdf_programacion_tejido = async (programaciontejido) => {
  let datos = [];
  try {
    const resp = await axiosConToken.get(
      `${PATH_PRODUCCION.programaciontejido}get_pdf_programacion_tejido/`,
      {
        responseType: "blob",
        params: { programaciontejido },
      },
    );
    datos = resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
  return datos;
};
export const get_pdf_prueba = async () => {
  try {
    const resp = await axiosConToken.get(
      `${PATH_PRODUCCION.programaciontejido}get_pdf_prueba/`,
      {
        responseType: "blob",
        // params: { programaciontejido },
      },
    );
    return resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
};
export const get_excel_programacionestejido_by_filters = async (filters) => {
  try {
    const resp = await axiosConToken.get(
      `${PATH_PRODUCCION.programaciontejido}get_excel_programacionestejido_by_filters/`,
      {
        responseType: "blob",
        params: filters,
      },
    );
    const file = resp.data;
    console.log(file);
    let name_file = "ProgramacionesTejido.xlsx";
    open_file(resp.data, name_file, file?.type);
  } catch (error) {
    validaMessagesErrors(error);
  }
};

export const get_detallecomprobantemovimientos_produccion = async () => {
  let datos = [];
  try {
    const resp = await axiosConToken.get(
      `${PATH_PRODUCCION.programaciontejido}get_detallecomprobantemovimientos_produccion/`,
    );
    datos = resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
  return datos;
};

export const get_pdf_programacion_tintoreria = async (
  programaciontintoreria,
) => {
  let datos = [];
  try {
    const resp = await axiosConToken.get(
      `${PATH_PRODUCCION.programaciontintoreria}get_pdf_programacion_tintoreria/`,
      {
        responseType: "blob",
        params: { programaciontintoreria },
      },
    );
    datos = resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
  return datos;
};
export const get_excel_programacionestintoreria = async (
  keys_programaciones,
) => {
  const msgload = messageLoading("Descargando...");
  try {
    const resp = await axiosConToken.get(
      `${PATH_PRODUCCION.programaciontintoreria}get_excel_programacionestintoreria/`,
      {
        responseType: "blob",
        params: { keys_programaciones },
      },
    );
    messageSuccessLoading(msgload, "El archivo se descargo correctamente");
    return resp.data;
  } catch (error) {
    validaMessagesErrors(error, msgload);
  }
};
export const get_excel_consolidacionestela = async (keys_programaciones) => {
  const msgload = messageLoading("Descargando...");
  try {
    const resp = await axiosConToken.get(
      `${PATH_PRODUCCION.programaciontintoreria}get_xls_consolidacionestela/`,
      {
        responseType: "blob",
        params: { keys_programaciones },
      },
    );
    messageSuccessLoading(msgload, "El archivo se descargo correctamente");
    return resp.data;
  } catch (error) {
    validaMessagesErrors(error, msgload);
  }
};
export const search_programaciontejido_by_filter = async (filter) => {
  let datos = [];
  try {
    const resp = await axiosConToken.get(
      `${PATH_PRODUCCION.programaciontintoreria}search_programaciontejido_by_filter/`,
      { params: { filter } },
    );
    datos = resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
  return datos;
};
export const search_comprobantecompras_by_filter = async (
  proveedor,
  filter,
) => {
  let datos = [];
  try {
    const resp = await axiosConToken.get(
      `${PATH_PRODUCCION.programaciontintoreria}search_comprobantecompras_by_filter/`,
      { params: { proveedor, filter } },
    );
    datos = resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
  return datos;
};
export const list_detalleprogramaciontintoreria_by_programaciontintoreria =
  async (programaciontintoreria) => {
    let datos = [];
    try {
      const resp = await axiosConToken.get(
        `${PATH_PRODUCCION.programaciontintoreria}list_detalleprogramaciontintoreria_by_programaciontintoreria/`,
        { params: { programaciontintoreria } },
      );
      datos = resp.data;
    } catch (error) {
      validaMessagesErrors(error.response);
    }
    return datos;
  };
export const get_maquinas_select = async () => {
  let datos = [];
  try {
    const resp = await axiosConToken.get(
      `${PATH_PRODUCCION.maquina}get_maquinas_select/`,
    );
    datos = resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
  return datos;
};
export const get_tareasproduccion = async () => {
  let datos = [];
  try {
    const resp = await axiosConToken.get(
      `${PATH_PRODUCCION.rutaproduccion}get_tareasproduccion/`,
    );
    datos = resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
  return datos;
};

export const get_items_a_producir = async () => {
  let datos = [];
  try {
    const resp = await axiosConToken.get(
      `${PATH_PRODUCCION.ordenproduccion}get_items_a_producir/`,
    );
    datos = resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
  return datos;
};
export const get_estados = async () => {
  let datos = [];
  try {
    const resp = await axiosConToken.get(
      `${PATH_PRODUCCION.ordenproduccion}get_estados/`,
    );
    datos = resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
  return datos;
};
export const get_unidadesmedida = async () => {
  let datos = [];
  try {
    const resp = await axiosConToken.get(
      `${PATH_PRODUCCION.ordenproduccion}get_unidadesmedida/`,
    );
    datos = resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
  return datos;
};

export const get_ordenesproduccion = async () => {
  let datos = [];
  try {
    const resp = await axiosConToken.get(
      `${PATH_PRODUCCION.procesoproduccion}get_ordenesproduccion/`,
    );
    datos = resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
  return datos;
};
export const get_proveedores = async () => {
  let datos = [];
  try {
    const resp = await axiosConToken.get(
      `${PATH_PRODUCCION.procesoproduccion}get_proveedores/`,
    );
    datos = resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
  return datos;
};
export const get_empleados = async () => {
  let datos = [];
  try {
    const resp = await axiosConToken.get(
      `${PATH_PRODUCCION.procesoproduccion}get_empleados/`,
    );
    datos = resp.data;
  } catch (error) {
    validaMessagesErrors(error.response);
  }
  return datos;
};
export const get_unidades_medida = async () => {
  let datos = [];
  try {
    const resp = await axiosConToken.get(
      `${PATH_PRODUCCION.procesoproduccion}get_unidadesmedida/`,
    );
    datos = resp.data;
  } catch (error) {
    validaMessagesErrors(error.response);
  }
  return datos;
};
export const get_estados_procesoproduccion = async () => {
  let datos = [];
  try {
    const resp = await axiosConToken.get(
      `${PATH_PRODUCCION.procesoproduccion}get_estados/`,
    );
    datos = resp.data;
  } catch (error) {
    validaMessagesErrors(error.response);
  }
  return datos;
};

export const list_detalleprogramacionestintorerias_cumplidos = async () => {
  let datos = [];
  try {
    const resp = await axiosConToken.get(
      `${PATH_PRODUCCION.consolidadotela}list_detalleprogramacionestintorerias_cumplidos/`,
    );
    datos = resp.data;
  } catch (error) {
    validaMessagesErrors(error.response);
  }
  return datos;
};

export const get_solo_almacenes = async () => {
  let datos = [];
  try {
    const resp = await axiosConToken.get(
      `${PATH_PRODUCCION.programaciontintoreria}get_solo_almacenes/`,
    );
    datos = resp.data;
  } catch (error) {
    validaMessagesErrors(error.response);
  }
  return datos;
};
export const search_items_by_param = async (param) => {
  let datos = [];
  try {
    const resp = await axiosConToken.get(
      `${PATH_PRODUCCION.consolidadotela}search_items_by_param/`,
      {
        params: { param },
      },
    );
    datos = resp.data;
  } catch (error) {
    validaMessagesErrors(error.response);
  }
  return datos;
};

export const get_pdf_consolidado_tela = async (consolidadotela) => {
  try {
    const resp = await axiosConToken.get(
      `${PATH_PRODUCCION.consolidadotela}get_pdf_consolidacion_tela/`,
      {
        responseType: "blob",
        params: { consolidadotela },
      },
    );
    return resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
};

export const get_tiposmovimientoentrada_porproduccion = async () => {
  try {
    const resp = await axiosConToken.get(
      `${PATH_PRODUCCION.resumenproduccion}get_tiposmovimientoentrada_porproduccion/`,
    );
    return resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
};
